import { EnvUrls } from "@asantech/common/express/types";
import client from "./client";
import { ApiEndpoints } from "./endpoints";

export const getAppUrls = async () => {
  const response = await client.get<EnvUrls>(`${ApiEndpoints.AppUrls}`);
  return response.data;
};
